import React from 'react';
import ProductCarousel from './product-carousel';
import ResponsiveProductCarousel from './responsive-product-carousel';
import ProductCarouselCard from '../../blog/components/product-carousel/product-carousel-card';
import { StoreAppAPI } from '../../core/src/storeapp-api-client';
import { Helpers } from '../../core/src/helpers';

const storeAppAPI = new StoreAppAPI();

class DynamicProductCarousel extends React.PureComponent{

    static MAX_PRODUCTS = 8;
    state = {
        productSkus: []
    }

    componentDidMount(){
        let {vanityUrl} = this.props;
        let searchQuery = this.createSearchQuery();

        if(searchQuery){
            try{
                DynamicProductCarousel.searchProducts(searchQuery, vanityUrl)
                    .then( parsedSkus => this.setState({productSkus: parsedSkus}) )
            }catch(e){}
        }
    }

    static searchProducts = Helpers.memoize(
        (searchQuery, vanityUrl) => {
            let errorTitle =`Error fetching Elastic Search products from page "${vanityUrl}"`;
            return storeAppAPI.product.es.search_v3(searchQuery)
                              .then(resp => {
                                    let parsedSkus = DynamicProductCarousel.parseSearchedProducts(resp);
                                    if( parsedSkus.length === 0 ){
                                        storeAppAPI.logger.log({
                                            message: `${errorTitle}: Query returned 0 results. Actual query: ${JSON.stringify(searchQuery)}`,
                                            info: `${errorTitle}.`,
                                            level: 'error',
                                        });
                                    }
                                    return parsedSkus;
                              })
                              .catch(error => {
                                storeAppAPI.logger.log({
                                    message: `${errorTitle}: Error: ${error}. Actual query: ${JSON.stringify(searchQuery)}`,
                                    info: `${errorTitle}.`,
                                    level: 'error',
                                });
                                return [];
                            })
        },
        (searchQuery) => {
            try{
                return JSON.stringify(searchQuery);
            }catch(e){}
        }
    );

    static parseSearchedProducts = (resp) => {
        try{
          let results = resp.data.hits.hits.map(prd => prd._source);
          return results;
        }catch(e){}
        return [];
    }

    createSearchQuery(){
        let {categories, facets, sort} = this.props;
        if(!categories && !facets){
            return null;
        }

        const query = {
            cat: categories && categories.length > 0
                ? categories[0].key // only 1 category supported for now
                : 'all-hp-products' // default if no categories specified, to prevent error
        };

        if(facets){
            Object.values(facets).forEach(({alias, facetValues}) => {
                try{
                    let facetValueParams = facetValues.reduce( (fvString, {alias}) => {
                                                fvString += fvString.length > 0 ? `,${alias}` : alias
                                                return fvString
                                            }, '');
                    if(facetValueParams.length){
                        query['facets.'+alias] = facetValueParams;
                    }
                }catch(e){}
            });
        }

        let searchQuery = {
            filters: query,
            from: 0,
            size: DynamicProductCarousel.MAX_PRODUCTS,
            sort: sort && sort.field && sort.order ? { [sort.field]: sort.order } : {}
        };

        return searchQuery;
    }


    render(){
        let {productSkus} = this.state;

        if(!productSkus || productSkus.length === 0){
            return null;
        }

        let {renderBottomCenterControls, slideWidth, initialSlideHeight, isV2, ...rest} = this.props;
        let carouselProps = {
            renderBottomCenterControls,
            slideWidth,
            initialSlideHeight,
            skus: productSkus,
            render: (key, product) => {
                    const {active} = product;
                    if(active) {
                        return (
                            <ProductCarouselCard key={key} product={product}/>
                        );
                    };
            },
            ...rest
        };

        return isV2
                ? <ResponsiveProductCarousel {...carouselProps} />
                : <ProductCarousel {...carouselProps} />;
    }
}

export default DynamicProductCarousel;
